import API_URL from "./config";

export function getFileUrl(fileName) {
  if (fileName)
    return `${API_URL}/images/${fileName}`
  return null
}
